module.exports = __webpack_public_path__ + "img/9_ava.4d449447.jpg";